module.exports = __webpack_public_path__ + "img/htcover_sample.fde78c71.png";